let timer,
    megaMenuTimer,
    didScroll,
    lastScrollTop = 0,
    delta = 5,
    navbarHeight = $('header').outerHeight();

export default class Menu {
  constructor () {
    this.init();
    this.initScrollBehavior();
    this.initMobile();
    this.initAnimationDuration();
  }

  init () {
    let that = this;

    that.setArrowPosition($('#nav-primary .menu-level-1')[0], false)

    $('#nav-primary .menu-level-1').on('mouseover', function () {
      if ($(this).hasClass('menu-item-has-children')) {
        clearTimeout(timer);
        $('#nav-primary .menu-level-1.is-active').removeClass('is-active');
        $('#nav-primary .sub-menu-container.is-showing').removeClass('is-showing');
        $(this).addClass('is-active');
        $(this).children('.sub-menu-container').addClass('is-showing');
        $(this).closest('.nav-primary').addClass('is-open');
        $('body').addClass('nav-is-open');

        if ($(this).hasClass('has-mega-menu')) {
          const height = that.getTallestSubmenu(this);
          $(this).find('.sub-menu-container').height(height + 100);
          document.querySelector(':root').style.setProperty('--mega-menu-divider', height + "px");
        }

        that.setArrowPosition(this)
      } else {
        that.hideSubMenu()
      }
    });

    $('#nav-primary .sub-menu-container > .sub-menu-wrapper > .sub-menu-inner-content > .sub-menu').each(function() {
      $(this).find('> .menu-item').each(function(i) {
        const mainAnchor = $(this).find('> .anchor-wrapper');
        mainAnchor.css('animation-delay', (i * 60) + 'ms');
        mainAnchor.css('opacity', 0);

        $(this).find('> .sub-menu > .menu-item').each(function(i) {
          $(this).find('> .anchor-wrapper').css('animation-delay', ((i+1) * 80) + 'ms');
          $(this).find('> .anchor-wrapper').css('opacity', 0);

          $(this).find('> .sub-menu > .menu-item').each(function(i) {
            $(this).find('> .anchor-wrapper').css('animation-delay', ((i+1) * 100) + 'ms');
            $(this).find('> .anchor-wrapper').css('opacity', 0);
          });
        });
      });
    });

    that.setRegularMenuWidth()

    window.addEventListener('resize', function () {
      that.setRegularMenuWidth(true)
      that.setArrowPosition($('#nav-primary .menu-level-1')[0], false)
    });

    $('.nav').on('mouseleave', () => {
      that.hideSubMenu()
    });
  }

  setArrowPosition (element, isShow = true) {
    const arrow = $('#nav-arrow')

    let elPosition = $(element).position().left
    let arrowWidth = arrow.width()
    let position = elPosition + arrowWidth

    arrow.css({ 'transform': 'translateX('+position+'px)' })
    arrow.addClass('transition-transform duration-300')

    if (isShow) {
      arrow.show()
    }
  }

  hideSubMenu () {
    let that = this;
    
    timer = setTimeout(function () {
      $('body').removeClass('nav-is-open');
      $('#nav-primary').removeClass('is-open');
      $('#nav-primary .sub-menu-container.is-showing').removeClass('is-showing');
      $('#nav-primary .menu-level-1.is-active').removeClass('is-active');
      // hide arrow and reset position
      $('#nav-arrow').hide()
      $('#nav-arrow').css({ 'transform': null })
      that.setRegularMenuWidth(true)
    }, 300);
  }

  setRegularMenuWidth (isRedraw = false) {
    let that = this
    $('#nav-primary .menu-level-1.has-regular-menu').each((index, element) => {
      let width = $('#menu-header-menu').width() - 32;
      $(element).find('.sub-menu-wrapper').css({
        'maxWidth': width+'px',
        'left': $('#menu-header-menu').offset().left,
      });

      if ($(element).find('.featured-box').length) {
        let subMenuWidth = $(element).find('.sub-menu').width()
        let menuItemWidth = $(element).find('.sub-menu .anchor-wrapper').width()
        let featuredBoxWidth = subMenuWidth - menuItemWidth;
        $(element).find('.featured-box').css({ 'width': featuredBoxWidth + 'px' })

        let firstItemID = $(element).find('.featured-box').first().closest('.menu-item').attr('id');
        that.setFeaturedBox(element, firstItemID, true);
      }

      if (isRedraw) return;

      if ($(element).find('.featured-box').length) {
        $(element).addClass('has-featured-box');
      }

      $(element).find('.menu-item > span > a').on('mouseover', function () {
        that.setFeaturedBox(element, $(this).closest('.menu-item').attr('id'));
      });
    });

    $('#nav-primary .menu-level-1.has-mega-menu').each((index, element) => {
      let width = $('.header-wrapper').width() - 32;
      $(element).find('.sub-menu-wrapper').css({
        'maxWidth': width + 'px',
        'left': $('.aptim-header-logo').offset().left,
      });

      if ($(element).find('.menu-level-2').length) {
        $(element).find('.menu-level-2.active').removeClass('active');
        $(element).find('.menu-level-2').first().addClass('active');
        $(element).find('.menu-level-2').first().addClass('init-active');
      }

      if ($(element).find('.menu-level-3').length) {
        $(element).find('.menu-level-3.active').removeClass('active');
        $(element).find('.menu-level-3').first().addClass('active');
        $(element).find('.menu-level-3').first().addClass('init-active');
      }

      $(element).find('.menu-level-2 > span > a').on('mouseover', function () {
        clearTimeout(megaMenuTimer);
        that.setMegaMenuSection(element, $(this).closest('.menu-item'), '.menu-level-2', that);
      })

      $(element).find('.menu-level-3 > span > a').on('mouseover', function () {
        clearTimeout(megaMenuTimer);
        that.setMegaMenuSection(element, $(this).closest('.menu-item'), '.menu-level-3', that);
      })
    })
  }

  getTallestSubmenu (element) {
    let tallestSubmenu = 0;
    element.querySelectorAll('.sub-menu').forEach((el) => {
        tallestSubmenu = tallestSubmenu > el.offsetHeight ? tallestSubmenu : el.offsetHeight;
    });

    return tallestSubmenu;
  }

  setFeaturedBox (element, id, init = false) {
    const active = $(element).find('.featured-box.active').parent();
    if (init) {
      $('#'+id).addClass('init-active');
    }

    if ($(active).attr('id') !== id) {
      $(active).removeClass('init-active');
      $(active).removeClass('active');
      $(active).find('.featured-box').removeClass('active');
      $('#'+id).addClass('active');
      $('#'+id).find('.featured-box').addClass('active');
      $('#'+id).find('.featured-box .title.aos-animate').removeClass('aos-animate');

      setTimeout(() => {
        $(element).find('.featured-box.active .title.aos-init').addClass('aos-animate');
      }, 100);
    }
  }

  setMegaMenuSection (element, currentElement, levelClass, that) {
    megaMenuTimer = setTimeout(function () {
      $(element).find('.init-active').removeClass('init-active');
      $(element).find(levelClass + '.active').removeClass('active');
      $(currentElement).addClass('active');
      $(currentElement).find('.sub-menu li.menu-item').removeClass('active');
      $(currentElement).find('.sub-menu li.menu-item').first().addClass('active');
      $(currentElement).find('.sub-menu li.menu-item').first().addClass('init-active');
      const height = that.getTallestSubmenu(element);
      $(currentElement).parents('.sub-menu-container').height(height + 100);
      document.querySelector(':root').style.setProperty('--mega-menu-divider', height + "px");
    }, 300)
  }

  // drawFeaturedBoxItems (element) {
  //   let that = this
  //   let content = ''
  //   $(element).find('.menu-meta').each((index, el) => {
  //     let title = $(el).find('.title').text();
  //     let image = $(el).find('.image') ? $(el).find('.image').text() : false
  //     let description = $(el).find('.description').html()
  //     let permalink = $(el).find('.permalink').text()
  //     let id = $(el).closest('li').attr('id')

  //     content += `<div class="featured-box-inner" data-id="${id}">`;
  //     content += that.featuredBoxHtml(title, image, description, permalink)
  //     content += '</div>';
  //   })

  //   $(element).find('.sub-menu-wrapper').append(`
  //     <div class="featured-box">${content}</div>
  //   `)
  // }

  // featuredBoxHtml (title, image, description, permalink) {
  //   let str = '';

  //   if (image) {
  //     str += `<div class="bg-image" style="background-image: linear-gradient(45deg, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 100%), url(${image});"></div>`;
  //   }

  //   str += '<div class="content">';
  //   str += `<h2 class="title">${title}</h2>`;
  //   str += `<p class="description">${description}</p>`;
  //   str += `<div><a href="${permalink}" class="permalink">LEARN MORE</a></div>`;
  //   str += '</div>';

  //   return str;
  // }

  initMobile () {
    $('.btn-mobile-nav').on('click', function () {
      if (! $(this).find('button').hasClass('is-active')) {
        $('#nav-mobile').addClass('is-open');
        $('body').addClass('mobile-nav-is-open');
        window.scrollTo(0, 0);
      } else {
        $('#nav-mobile').removeClass('is-open');
        $('#nav-mobile .is-open').removeClass('is-open');
        $('#nav-mobile .menu-all-item').hide();
        $('body').removeClass('mobile-nav-is-open');
      }
    });

    window.addEventListener('click', function (e) {
      // Templates without the site header (Landing Page, Content Only) have neither of
      // these, and an unguarded .contains() here throws on every click on the page.
      const btn = document.querySelector('.btn-mobile-nav')
      const nav = document.querySelector('.nav-mobile')

      if (!btn || !nav) return;

      if (!btn.contains(e.target) && !nav.contains(e.target)) {
        $('#nav-mobile').removeClass('is-open');
        $('#nav-mobile .is-open').removeClass('is-open');
        $('#nav-mobile .menu-all-item').hide();
        $('body').removeClass('mobile-nav-is-open');
      }
    });

    // We'll have to handle the resize event like this
    // because some mobile browsers fire the resize event even
    // if just scrolling. See more here -> https://stackoverflow.com/questions/9361968/javascript-resize-event-on-scroll-mobile
    let cachedWidth = $(window).width();
    window.addEventListener('resize', function () {
      let newWidth = $(window).width();

      if(newWidth !== cachedWidth){
        $('#nav-mobile').removeClass('is-open');
        $('#nav-mobile .is-open').removeClass('is-open');
        $('#nav-mobile .menu-all-item').hide();
        $('body').removeClass('mobile-nav-is-open');
        cachedWidth = newWidth;
      }
    }, true);

    $('#nav-mobile .menu-child-item:not(.is-parent)').on('click', function () {
      const menuItem = $(this).closest('.menu-item');
      // const grandparent = $(this).parent('.is-grandparent');
      const navItem = menuItem.parent('.nav');
      const submenu = menuItem.parent('.sub-menu');

      if ($(this).hasClass('is-grandparent')) {
        const currentmenuItem = $(this).closest('.menu-item.is-open');
        currentmenuItem.removeClass('is-open');
        if (currentmenuItem.parent('.nav').length) {
          currentmenuItem.parent('.nav').removeClass('is-open');
        } else if (currentmenuItem.parent('.sub-menu').length) {
          currentmenuItem.parent('.sub-menu').removeClass('is-open');
        }
      } else {
        if (!menuItem.hasClass('is-open')) {
          if (navItem.length) {
            navItem.addClass('is-open');
          } else if (submenu.length) {
            submenu.addClass('is-open');
          }
          menuItem.addClass('is-open');
        }
      }
    });
  }

  initScrollBehavior () {
    let that = this
    $(window).on('scroll', function () {
      didScroll = true;
    });

    setInterval(function () {
      if (didScroll) {
        that.hasScrolled();
        didScroll = false;
      }
    }, 250);
  }

  hasScrolled() {
    let st = $(window).scrollTop()

    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta) return;

    // If they scrolled down and are past the navbar, add class .active.
    if (st > lastScrollTop && st > navbarHeight) {
      // scroll down
      if (!$('.nav-mobile ').hasClass('is-open') && !$('.nav-primary').hasClass('is-open')) {
        $('header').removeClass('active')
      }

      if (!$('.aptim-floating-cta').hasClass('active')) {
        $('.aptim-floating-cta').addClass('active');
      }
    } else {
      // scroll up
      if (st + $(window).height() < $(document).height() && !$('header').hasClass('active')) {
        $('header').addClass('active')
      }

      if (document.querySelector('.aptim-hero-wrapper') && this.isInViewport(document.querySelector('.aptim-hero-wrapper'))) {
        $('.aptim-floating-cta').removeClass('active');
      }
    }

    // save last scroll position
    lastScrollTop = st;
  }

  isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
    );
  }

  initAnimationDuration() {
    const links = document.querySelectorAll('.anchor-wrapper a, .cat-filter-nav a, .filter-by, .link-underlined-hover-2, .link-more, .home-banner-items a');

    links.forEach((link) => {
      const textLength = link.innerText.trim().length;
      const animationDuration = Math.min(textLength * 0.02, .7);
      link.style.transitionDuration = animationDuration + 's';
      link.style.animationDuration = animationDuration + 's';
    });
  }
}
